<template>
  <prismic-rich-text :field="title" class="page-title" :style="{ color }"></prismic-rich-text>
</template>

<script>
export default {
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      title: '',
      color: '#000'
    };
  },
  created() {
    this.title = this.slice?.primary?.title1;
    this.color = this.slice?.primary?.font_color;
  }
};
</script>

<style lang="scss">
.page-title {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 25px;
    text-align: center;
    margin: 0;
  }
}
</style>
